export default __webpack_public_path__ + "static/media/custom-addon.4a1057f1.svg";